import { ResolveFn } from '@angular/router';
import { EquipoService } from '../services/equipo-service';
import { inject } from '@angular/core';
import { of, catchError } from 'rxjs';

export const equipoResolver: ResolveFn<any> = (route, state) => {
  const equipoService = inject(EquipoService);
  const id = route.paramMap.get('id');
  if (!id) {
    return of(null);
  }
  return equipoService.getEquipoById(id).pipe(
    catchError(() => of(null))
  );
};